<template>
    <div>
        <el-card class="login-card" style="width: 500px">
            <el-tabs v-model="activeName" stretch="stretch" @tab-click="changeTab">
                <el-tab-pane label="登录" name="login">
                    <el-form :label-position="labelPosition" label-width="95px" ref="userLogin" :rules="loginRules"
                             :model="userLogin">
                        <el-form-item label="账号" prop="username">
                            <el-input v-model="userLogin.username" placeholder="请输入邮箱或身份证号码"></el-input>
                        </el-form-item>
                        <el-form-item label="密码" prop="password">
                            <el-input type="password" v-model="userLogin.password" placeholder="请输入密码"></el-input>
                        </el-form-item>
                        <el-form-item label="验证码" prop="verifyCode">
                            <el-input v-model="userLogin.verifyCode" @keyup.enter.native="login">
                                <img style="padding:0px;height:40px;border:0px" ref="verifyCodeImg" slot="append"
                                     src="/api/genCode" @click="genCode()"/>
                            </el-input>
                        </el-form-item>
                        <el-form-item label-width="0">
                            <el-row>
                                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                    <el-checkbox v-model="isRememberAccount">记住账号</el-checkbox>
                                </el-col>
                                <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12">
                                    <p class="link">
                                    </p>
                                </el-col>
                            </el-row>
                        </el-form-item>

                        <!-- <el-form-item> -->
                        <el-button size="small" type="primary" class="large-bt" @click="login">登录</el-button>
                        <!-- </el-form-item> -->
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="注册" name="register">
                    <el-form :label-position="labelPosition" label-width="95px" ref="userRegister"
                             :rules="registerRules" :model="userRegister">
                        <el-form-item label="姓名" prop="chName">
                            <el-input v-model="userRegister.chName"></el-input>
                        </el-form-item>
                        <el-form-item label="姓名拼音" prop="enName">
                            <el-col :span="12">
                                <el-tooltip effect="light"
                                        content="名字拼音，将用于制作证书"
                                        placement="right">
                                    <el-input placeholder="Xiaoming" v-model="userRegister.firstName"></el-input>
                                </el-tooltip>
                            </el-col>
                            <el-col :span="12">
                                <el-tooltip effect="light"
                                            content="姓氏拼音，将用于制作证书"
                                            placement="right">
                                    <el-input placeholder="Wang" v-model="userRegister.lastName"></el-input>
                                </el-tooltip>
                            </el-col>
                        </el-form-item>
                        <el-form-item label="手机" prop="tel">
                            <el-input type="tel" v-model="userRegister.tel"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号码" prop="certNo">
                            <el-row>
                                <el-col :span="24">
                                    <el-input v-model="userRegister.certNo" @blur="searchEmail"></el-input>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="邮箱" prop="email">
                            <el-row>
                                <el-col :span="24">
                                    <el-input v-model="userRegister.email" :disabled="!userRegister.editEmail"></el-input>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="验证码" prop="verifyCode">
                            <el-row>
                                <el-col :span="11">
                                    <el-input v-model="userRegister.verifyCode"></el-input>
                                </el-col>
                                <el-col :span="12" :offset="1">
                                    <el-button @click="getRegisterVerifyCode()" :class="{'disable-bt':mailTipsTime>0}">
                                        {{ mailTips }}
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                        <el-form-item label="单位" prop="company">
                            <el-input v-model="userRegister.company"></el-input>
                        </el-form-item>
                        <el-form-item label="职务" prop="title">
                            <el-input v-model="userRegister.title"></el-input>
                        </el-form-item>
                        <el-form-item label="培训机构" prop="institutions">
                            <el-input v-model="userRegister.institutions"></el-input>
                        </el-form-item>
                        <el-form-item label="登录密码" prop="password">
                            <el-input v-model="userRegister.password" type="password"></el-input>
                        </el-form-item>
                        <el-form-item label="确认密码" prop="password_">
                            <el-input v-model="userRegister.password_" type="password"></el-input>
                        </el-form-item>
                        <!-- <el-form-item> -->
                        <el-button size="small" type="primary" class="large-bt" @click="register">注册</el-button>
                        <!-- </el-form-item> -->
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="找回密码" name="findPassword">
                    <el-form :label-position="labelPosition" ref="findPassword" :rules="formRules" :model="findPassword"
                             class="find-password">
                        <el-form-item label="账号" prop="username">
                            <el-row>
                                <el-col :span="14">
                                    <el-input v-model="findPassword.username"
                                              @keyup.enter.native="getEmailCode()" placeholder="请输入邮箱或身份证号码"></el-input>
                                </el-col>
                                <el-col :span="6" :offset="1">
                                    <el-button @click="getEmailCode()" :class="{'disable-bt':emailTime>0}">
                                        {{ emailTips }}
                                    </el-button>
                                </el-col>
                            </el-row>
                        </el-form-item>
                    </el-form>
                </el-tab-pane>
            </el-tabs>
        </el-card>
    </div>
</template>

<script>
import Bus from '../bus.js';

export default {
    props: {
        currentName: {
            type: String,
            default: "login"
        },
        closeDialogLogin: {
            type: Boolean,
            default: true
        },
    },
    data: function () {
        var userNameValidator=(rule,value,callback) => {
            const cert = new RegExp(/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/);
            const cert2 = new RegExp(/^[a-zA-Z]\d{6}\([\dA]\)$/);
            const email = new RegExp(/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/);
            if (!cert.test(value) && !cert2.test(value) && !email.test(value)) {
                callback(new Error("请出入正确的邮箱或者身份证号码"));
            } else {
                callback();
            }
        };
        var certNoValidator=(rule,value,callback) => {
            const cert = new RegExp(/^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/);
            const cert2 = new RegExp(/^[a-zA-Z]\d{6}\([\dA]\)$/);
            if (!cert.test(value) && ! cert2.test(value)) {
                callback(new Error("请出入正确的身份证号码"));
            } else {
                callback();
            }
        };
        var confirmPasswordValidator = (rule, value, callback) => {
            if (value !== this.findPassword.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        var confirmPasswordValidator = (rule, value, callback) => {
            if (value !== this.userRegister.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        var telValidator = (rule, value, callback) => {
            const reg = new RegExp(/^(?:\+?86)?1[3-9]\d{9}$|^(?:\+?852)?[569]\d{7}$|^(?:\+?853)?6\d{7}$|^(?:\+?886)?9\d{8}$/);
            if (!reg.test(value)) {
                callback(new Error("请输入正确的手机号码"));
            } else {
                callback();
            }
        };
        return {
            mailTips: "获取验证码",
            emailTips: "获取邮件",
            mailTipsTime: 0,
            emailTime: 0,
            emailTimer: "",
            activeName: "login",
            mailTipsTimer: "",
            isRememberAccount: false,
            certificateReg: {},
            labelPosition: "right",
            stretch: true,
            activeEmailVisible: false,
            findPassword: {
                email: ""
            },
            formRules: {
                username: [
                    {required: true, message: "请输入邮箱或者身份证号码", trigger: ["blur"]},
                    {validator: userNameValidator, trigger: ["blur"]}
                ]
            },
            //表单
            userLogin: {
                username: "",
                password: "",
                verifyCode: ""
            },
            userRegister: {
                editEmail: true,
                firstName: "",
                lastName: "",
                chName: "",
                tel: "",
                company: "",
                title: "",
                institutions: "",
                verifyCode: "",
                email: "",
                password: "",
                password_: "",
                enName: ""
            },
            //校验规则
            loginRules: {
                username: [
                    {required: true, message: "请输入邮箱或者身份证号码", trigger: ["blur"]},
                    {validator: userNameValidator, trigger: ["blur"]}
                ],
                password: [
                    {required: true, message: "请输入密码", trigger: ["blur"]}
                ],
                verifyCode: [
                    {required: true, message: "请输入验证码", trigger: ["blur"]}
                ]
            },
            registerRules: {
                email: [
                    {required: true, message: "请输入邮箱", trigger: ["blur"]},
                    {type: "email", message: "请输入正确的邮箱地址", trigger: ["blur"]}
                ],
                certNo: [
                    {required: true, message: "请输入身份证号码", trigger: ["blur"]},
                    {validator:certNoValidator, trigger: ["blur"]}
                ],
                company: [
                    {required: true, message: "请输入单位名称", trigger: ["blur"]}
                ],
                title: [
                    {required: true, message: "请输入职务", trigger: ["blur"]}
                ],
                firstName: [
                    {required: true, message: "请输入名字拼音", trigger: ["blur"]}
                ],
                lastName: [
                    {required: true, message: "请输入姓氏拼音", trigger: ["blur"]}
                ],
                chName: [{required: true, message: "请输入姓名", trigger: ["blur"]}],
                tel: [
                    {required: true, message: "请输入手机号码", trigger: ["blur"]},
                    {validator: telValidator, trigger: ["blur"]}
                ],
                verifyCode: [
                    {required: true, message: "请输入验证码", trigger: ["blur"]}
                ],
                password: [
                    {required: true, message: "请输入登录密码", trigger: ["blur"]}
                ],
                password_: [
                    {required: true, message: "请再次输入密码", trigger: ["blur"]},
                    {validator: confirmPasswordValidator, trigger: ["blur"]}
                ]
            },
        };
    },
    computed: {},
    mounted() {
        this.userLogin.username = localStorage.getItem("CSAAccount");
        if (this.userLogin.username) {
            this.isRememberAccount = true;
        }
        let winWidth;
        if (window.innerWidth) winWidth = window.innerWidth;
        else if (document.body && document.body.clientWidth)
            winWidth = document.body.clientWidth;
        this.labelPosition = winWidth > 480 ? "right" : "top";
        this.activeName = this.currentName;
    },
    watch: {
        currentName: function (val) {
            this.activeName = val;
        },
        closeDialogLogin: function (val) {
            if (val) {
                this.resetForm("userLogin");
                this.resetForm("userRegister");
                this.resetForm("findPassword");
            }
        }
    },
    methods: {
        changeTab(val) {
            Bus.$emit("changeTab", val.name);
            this.$refs.userLogin.clearValidate();
            this.$refs.userRegister.clearValidate();
            this.$refs.findPassword.clearValidate();
        },
        getEmailCode() {
            if (this.emailTime > 0) {
                return;
            }
            this.$refs.findPassword.validate((pass,object)=> {
                if (pass) {
                    this.$axios
                        .get("/openApi/getFindBackPasswordEmail", {
                            params: {
                                username: this.findPassword.username
                            }
                        })
                        .then(response => {
                            if (response.code === 200) {
                                this.emailTime = 120;
                                this.emailTips = `(${this.emailTime})重新获取`;
                                this.emailTimer = setInterval(() => {
                                    this.emailTime--;
                                    this.emailTips =
                                        this.emailTime > 0
                                            ? `(${this.emailTime})重新获取`
                                            : `重新获取`;
                                    if (this.emailTime <= 0) {
                                        clearInterval(this.emailTimer);
                                    }
                                }, 1000);
                                this.$message({
                                    message: `重置密码的链接已发送至你的邮箱${response.data}，请查收，如该邮箱无法登陆，请联系管理员修改`,
                                    type: "success"
                                });
                            }
                        });
                }
            });
        },

        async getRegisterVerifyCode() {
            if (this.mailTipsTime > 0) {
                return;
            }
            const validatePromise = (prop) => {
                return new Promise((resolve,reject) => {
                    this.$refs.userRegister.validateField(prop,error=> {
                        if (!error) {
                            resolve(true)
                        } else {
                            reject(false)
                        }
                    });
                })
            }

            Promise.all([validatePromise('email'),validatePromise('certNo'),validatePromise('chName')]).then(vr => {
                this.$axios
                    .get("/openApi/getRegisterVerifyCode", {
                        params: {
                            email: this.userRegister.email,
                            certNo: this.userRegister.certNo,
                            userName: this.userRegister.chName
                        }
                    })
                    .then(response => {
                        if (response.code === 200) {
                            this.mailTipsTime = 120;
                            this.mailTips = `(${this.mailTipsTime})重新获取`;
                            this.mailTipsTimer = setInterval(() => {
                                this.mailTipsTime--;
                                this.mailTips =
                                    this.mailTipsTime > 0
                                        ? `(${this.mailTipsTime})重新获取`
                                        : `重新获取`;
                                if (this.mailTipsTime <= 0) {
                                    clearInterval(this.mailTipsTimer);
                                }
                            }, 1000);
                            this.$message({
                                message: "验证码已发送至你的邮箱，请查收",
                                type: "success"
                            });
                        }
                    });
            }).catch(error => {
                console.log(error)
            })
            // if (reg.test(this.userRegister.email)) {
            //
            // }
        },

        async login(e) {
            let valid = await this.$refs["userLogin"].validate().catch(err => Promise.resolve(false));
            if (!valid) {
                return;
            }
            let loading = this.$loading({
                lock: true,
                text: "加载中",
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.7)"
            });
            //登录请求需要用application/x-www-form-rulencoded提交
            let res = await this.$axios.post("/login", this.userLogin,
                {
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded"
                    },
                    transformRequest: [function (data) {
                        let ret = "";
                        for (let it in data) {
                            ret += encodeURIComponent(it) + "=" + encodeURIComponent(data[it]) + "&";
                        }
                        return ret;
                    }
                    ]
                });
            loading.close()
            if (res.code === 601) {
                this.genCode();
                this.$message({message: res.errMsg, type: "error"});
                return;
            }
            if (res.code === 401) {
                this.genCode();
                return;
            }
            if (res.code !== 200) {
                this.$message({message: res.errMsg, type: "error"});
                return;
            }

            sessionStorage.setItem("skipFaceCertify", false);
            if (this.isRememberAccount) {
                localStorage.setItem("CSAAccount", this.userLogin.username);
            } else {
                localStorage.removeItem("CSAAccount");
            }

            window.location.reload();
        },

        genCode() {
            this.$refs.verifyCodeImg.src = `/api/genCode?time=${new Date().getTime()}`;
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        searchEmail: async function () {
            let res= await this.$axios.get(`/openApi/getEmail?certNo=${this.userRegister.certNo}`)
            if (res.code === 200 && null !== res.data) {
                this.userRegister.email = res.data;
                this.userRegister.editEmail=false
            } else if (res.code === 200 && null === res.data){
                this.userRegister.editEmail=true
            }
        },
        register: function () {
            this.$refs["userRegister"].validate(valid => {
                if (valid) {
                    const loading = this.$loading({
                        lock: true,
                        text: "注册中",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.7)"
                    });
                    this.userRegister.enName = (this.userRegister.firstName+" "+this.userRegister.lastName).trim();
                    this.userRegister.activityId = this.$route.query.activityId
                    this.userRegister.sourceUserId = this.$route.query.sourceUserId
                    this.$axios
                        .post("/openApi/register", this.userRegister)
                        .then(res => {
                            loading.close();
                            if (res.code === 200) {
                                this.$message({
                                    message: "注册成功",
                                    type: "success"
                                });
                                this.userRegister = {
                                    chName: "",
                                    tel: "",
                                    company: "",
                                    title: "",
                                    institutions: "",
                                    verifyCode: "",
                                    email: "",
                                    password: "",
                                    password_: ""
                                };
                                this.activeName = "login";
                            }
                        })
                        .catch(err => {
                            loading.close();
                        })
                        .finally(() => {
                            loading.close();
                        });
                }
            });
        }

    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.login-card {
    padding: 20px 40px 40px 40px;
}

.loading {
    min-height: 250px;
    line-height: 250px;
    font-size: 60px;
    color: #1564a7;
    text-align: center;
}

.disable-bt {
    cursor: not-allowed;
}

.disable-bt:hover,
.disable-bt:focus {
    background: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
}

.link {
    text-align: right;
    font-size: 14px;
    margin-bottom: 5px;
}

.link a {
    text-decoration: none;
}

.large-bt {
    width: 100%;
    font-size: 16px;
    background: #00549f;
}

@media screen and (max-width: 380px) {
    .el-button {
        padding-left: 5px;
        padding-left: 5px;
    }

    .large-bt {
        font-size: 14px;
    }
}

.login-btn {
    text-align: center;
}

.login-btn button {
    width: 100%;
    height: 36px;
}

.text {
    font-size: 14px;
}

.item {
    margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
    display: table;
    content: "";
}

.clearfix:after {
    clear: both;
}

.box-card {
    width: 480px;
}

/deep/ .find-password .el-form-item__error {
    left: 50px;
}

/deep/ .el-dialog__body {
    padding: 0;
}

/deep/ .el-dialog {
    max-width: 600px !important;
}

/deep/ .el-input-group__append {
    padding: 0;
    background-color: white;
    border: 0;
}
</style>
